export enum NavigationLevelEnum {
    NotSet,
    Home,
    Subscription,
    Hospital,
    Unit,
    UnitPlusOne,
    UnitPlusTwo,
    UnitPlusThree,
    UnitPlusFour,
    UnitPlusFive,
    UnitPlusSix,
    UnitPlusSeven,
    UnitPlusEight,
    UnitPlusNine,
    UnitPlusTen,
}
